import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";

const Sidebar = () => {
  const location = useLocation(); // Get the current route location
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false); // State to toggle mobile menu
// this is sidebar
  const isActive = (path) => location.pathname === path; // Check if a path is active

  return (
    <div>
      {/* Desktop Sidebar */}
      <div className="hidden md:flex h-screen bg-gray-100 border-r w-64 flex-col">
        {/* Logo */}
        <div className="p-6 text-center font-bold text-xl bg-primary text-black">
          FCS Admin Panel
        </div>
        {/* Sidebar Items */}
        <nav className="flex flex-col mt-6 space-y-4">
          <Link
            to="/admin/admin-orderlists"
            className={`p-4 ${isActive("/admin/admin-orderlists")
              ? "bg-gray-300 text-black font-bold"
              : "text-gray-700 hover:bg-gray-200 hover:text-black"
              } transition duration-200`}
          >
            <i className="fas fa-list mr-2"></i> Order Lists
          </Link>

          <Link
            to="/admin/sell-orders"
            className={`p-4 ${isActive("/admin/sell-orders")
              ? "bg-gray-300 text-black font-bold"
              : "text-gray-700 hover:bg-gray-200 hover:text-black"
              } transition duration-200`}
          >
            <i className="fas fa-user-friends mr-2"></i> Suppliers
          </Link>

          <Link
            to="/admin/admin-pricing"
            className={`p-4 ${isActive("/admin/admin-pricing")
              ? "bg-gray-300 text-black font-bold"
              : "text-gray-700 hover:bg-gray-200 hover:text-black"
              } transition duration-200`}
          >
            <i className="fas fa-dollar-sign mr-2"></i> Pricing
          </Link>
          <Link
            to="/admin/promo-codes"
            className={`p-4 ${isActive("/admin/promo-codes")
              ? "bg-gray-300 text-black font-bold"
              : "text-gray-700 hover:bg-gray-200 hover:text-black"
              } transition duration-200`}
          >
            <i className="fas fa-percentage mr-2"></i> Discount
          </Link>
          <Link
            to="/admin/cash-back"
            className={`p-4 ${isActive("/admin/cash-back")
              ? "bg-gray-300 text-black font-bold"
              : "text-gray-700 hover:bg-gray-200 hover:text-black"
              } transition duration-200`}
          >
            <i className="fas fa-wallet mr-2"></i> Set Cashback
          </Link>
          <Link
            to="/admin/all-users"
            className={`p-4 ${isActive("/admin/all-users")
              ? "bg-gray-300 text-black font-bold"
              : "text-gray-700 hover:bg-gray-200 hover:text-black"
              } transition duration-200`}
          >
            <i className="fas fa-users mr-2"></i> Registered Users
          </Link>
          <Link
            to="/admin/all-emails"
            className={`p-4 ${isActive("/admin/all-email")
              ? "bg-gray-300 text-black font-bold"
              : "text-gray-700 hover:bg-gray-200 hover:text-black"
              } transition duration-200`}
          >
            <i className="fas fa-envelope mr-2"></i> All Emails
          </Link>
          <Link
            to="/admin/showAllOrders"
            className={`p-4 ${isActive("/admin/all-email")
              ? "bg-gray-300 text-black font-bold"
              : "text-gray-700 hover:bg-gray-200 hover:text-black"
              } transition duration-200`}
          >
            <i className="fas fa-envelope mr-2"></i> All Orders
          </Link>

        </nav>
        {/* Logout */}

      </div>

      {/* Mobile Sidebar */}
      <div className="md:hidden bg-primary text-black">
        {/* Mobile Menu Toggle */}
        <div className="flex justify-between items-center px-4 py-3">
          <div className="font-bold text-lg">FCS Admin Panel</div>
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="text-2xl focus:outline-none"
          >
            <i className={`fas ${isMobileMenuOpen ? "fa-times" : "fa-bars"}`}></i>
          </button>
        </div>

        {/* Dropdown Menu */}
        {isMobileMenuOpen && (
          <nav className="bg-white text-black shadow-md">
            <Link
              to="/admin/admin-orderlists"
              className={`block px-4 py-2 ${isActive("/admin/admin-orderlists")
                ? "bg-gray-300 font-bold"
                : "hover:bg-gray-200"
                }`}
              onClick={() => setIsMobileMenuOpen(false)}
            >
              <i className="fas fa-list mr-2"></i> Order Lists
            </Link>

            <Link
              to="/admin/admin-pricing"
              className={`block px-4 py-2 ${isActive("/admin/admin-pricing")
                ? "bg-gray-300 font-bold"
                : "hover:bg-gray-200"
                }`}
              onClick={() => setIsMobileMenuOpen(false)}
            >
              <i className="fas fa-dollar-sign mr-2"></i> Pricing
            </Link>
            <Link
              to="/admin/sell-orders"
              className={`block px-4 py-2 ${isActive("/admin/sell-orders")
                ? "bg-gray-300 font-bold"
                : "hover:bg-gray-200"
                }`}
              onClick={() => setIsMobileMenuOpen(false)}
            >
              <i className="fas fa-user-friends mr-2"></i>  Suppliers
            </Link>
            <Link
              to="/admin/promo-codes"
              className={`block px-4 py-2 ${isActive("/admin/promo-codes")
                ? "bg-gray-300 font-bold"
                : "hover:bg-gray-200"
                }`}
              onClick={() => setIsMobileMenuOpen(false)}
            >
              <i className="fas fa-percentage mr-2"></i> Discount
            </Link>
            <Link
              to="/admin/cash-back"
              className={`block px-4 py-2 ${isActive("/admin/cash-back")
                ? "bg-gray-300 font-bold"
                : "hover:bg-gray-200"
                }`}
              onClick={() => setIsMobileMenuOpen(false)}
            >
              <i className="fas fa-wallet mr-2"></i> Set Cashback
            </Link>

            <Link
              to="/admin/all-users"
              className={`block px-4 py-2 ${isActive("/admin/all-users")
                ? "bg-gray-300 font-bold"
                : "hover:bg-gray-200"
                }`}
              onClick={() => setIsMobileMenuOpen(false)}
            >
              <i className="fas fa-users mr-2"></i> Registered Users
            </Link>
            <Link
              to="/admin/all-emails"
              className={`block px-4 py-2 ${isActive("/admin/all-emails")
                ? "bg-gray-300 font-bold"
                : "hover:bg-gray-200"
                }`}
              onClick={() => setIsMobileMenuOpen(false)}
            >
              <i className="fas fa-envelope mr-2"></i> All Emails
            </Link>
            <Link
              to="/admin/showAllOrders"
              className={`block px-4 py-2 ${isActive("/admin/all-emails")
                ? "bg-gray-300 font-bold"
                : "hover:bg-gray-200"
                }`}
              onClick={() => setIsMobileMenuOpen(false)}
            >
              <i className="fas fa-envelope mr-2"></i> All Orders
            </Link>




          </nav>
        )}
      </div>
    </div>
  );
};

export default Sidebar;
